module.exports = __webpack_public_path__ + "img/Image_logo_2.c3fa0d30.jpg";